import { useSearchParams } from 'react-router-dom';
import { useCallback } from 'react';

export const useURLFilters = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  const getFiltersFromURL = useCallback(() => ({
    search: searchParams.get('search') || '',
    page: parseInt(searchParams.get('page') || '1'),
    limit: parseInt(searchParams.get('limit') || '30'),
    states: searchParams.get('states')?.split(',').filter(Boolean) || [],
    stores: searchParams.get('stores')?.split(',').filter(Boolean) || [],
    transportadoras: searchParams.get('transportadora')?.split(',').filter(Boolean) || [],
    paymentMethods: searchParams.get('paymentMethod')?.split(',').filter(Boolean) || [],
    destinos: searchParams.get('destino')?.split(',').filter(Boolean) || 
              searchParams.get('destino_cotizacion')?.split(',').filter(Boolean) || [],
    startDate: searchParams.get('startDate') || '',
    endDate: searchParams.get('endDate') || '',
    sortBy: searchParams.get('sortBy') || 'date_created',
    order: (searchParams.get('order') as 'asc' | 'desc') || 'desc',
    agent: searchParams.get('agent') || '',
    agente: searchParams.get('agente') || ''
  }), [searchParams]);
  
  const updateURL = useCallback((filters: any) => {
    const newParams = new URLSearchParams();
    
    if (filters.search) newParams.set('search', filters.search);
    if (filters.page > 1) newParams.set('page', filters.page.toString());
    if (filters.limit !== 30) newParams.set('limit', filters.limit.toString());
    if (filters.states?.length) newParams.set('states', filters.states.join(','));
    if (filters.stores?.length) newParams.set('stores', filters.stores.join(','));
    if (filters.transportadoras?.length) newParams.set('transportadora', filters.transportadoras.join(','));
    if (filters.paymentMethods?.length) newParams.set('paymentMethod', filters.paymentMethods.join(','));
    if (filters.destinos?.length) {
      // Usar destino_cotizacion si está especificado, sino destino
      if (filters.destinoKey === 'destino_cotizacion') {
        newParams.set('destino_cotizacion', filters.destinos.join(','));
      } else {
        newParams.set('destino', filters.destinos.join(','));
      }
    }
    if (filters.startDate) newParams.set('startDate', filters.startDate);
    if (filters.endDate) newParams.set('endDate', filters.endDate);
    if (filters.sortBy !== 'date_created') newParams.set('sortBy', filters.sortBy);
    if (filters.order !== 'desc') newParams.set('order', filters.order);
    if (filters.agent) newParams.set('agent', filters.agent);
    if (filters.agente) newParams.set('agente', filters.agente);
    
    setSearchParams(newParams);
  }, [setSearchParams]);
  
  return { getFiltersFromURL, updateURL };
};